module.exports = __webpack_public_path__ + "static/media/17.6d50ad5e.jpg";